import React from "react";
import { Flex, Provider, Segment } from "@fluentui/react-northstar";
import ImageTitleContainer from "../ImageTitleContainer";
import SecureLoginImage from "../../../assets/images/undraw_secure_login_pdn4.svg";
import Constants from "../../../constants/text-constants";
import ChangePasswordForm from "../../molecules/Forms/ChangePasswordForm";
import { observer } from "mobx-react-lite";
import PropTypes from "prop-types";

const ChangePassword = observer((props) => {
  const { changePasswordComplete } = props;

  const bgClass = "page full-screen";
  const bgClassSegment = "change-password-container segment";

  return (
    <Provider.Consumer
      render={(theme) => (
        <Flex
          className={
            theme.siteVariables.themeString === "default"
              ? bgClass + " bg-onboarding default"
              : bgClass
          }
          data-testid="changePassword"
        >
          <Segment
            className={
              theme.siteVariables.themeString === "dark"
                ? bgClassSegment + " dark"
                : bgClassSegment
            }
            data-testid="changePasswordSegment"
          >
            <ImageTitleContainer
              image={SecureLoginImage}
              title={Constants.CHANGE_PASSWORD}
              subTitle={Constants.USE_PASSWORD_TO_SIGN_IN_FROM_NOW_ON}
              testId="changePasswordContainer"
            >
              <ChangePasswordForm
                changePasswordComplete={changePasswordComplete}
              />
            </ImageTitleContainer>
          </Segment>
        </Flex>
      )}
    ></Provider.Consumer>
  );
});

ChangePassword.propTypes = {
  changePasswordComplete: PropTypes.func,
};

export default ChangePassword;
